import Route from '@ember/routing/route';

import type { CoachingCoachSessionsModel } from '../sessions';

export type CoachingCoachSessionsActionRequiredModel =
  CoachingCoachSessionsModel;

export default class CoachingCoachSessionsActionRequiredRoute extends Route<CoachingCoachSessionsActionRequiredModel> {
  model(): CoachingCoachSessionsActionRequiredModel {
    return this.modelFor(
      'coaching.coach.sessions'
    ) as CoachingCoachSessionsActionRequiredModel;
  }
}
